// All auth/2FA/profile calls authenticate via the first-party Sanctum session
// cookie + XSRF token (axios is configured with withCredentials + withXSRFToken
// in bootstrap.js). We no longer attach a bearer token read from localStorage,
// which removed the XSS token-theft surface (SUPPORT-663 / F-024).
class Auth {
    constructor() {}

    login(creds) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/login', creds);
        });
    }

    register(creds) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/register', creds);
        });
    }

    sendForgotPasswordLink(email) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/forgot-password', { email: email });
        });
    }

    resetPassword(creds) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/reset-password', creds);
        });
    }

    logout() {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/logout');
        });
    }

    enableSms2fa(phone, password) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/api/2fa/enableSms2fa', {
                phone: phone,
                password: password,
            });
        });
    }

    submitTwoFA(code) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/2fa', code);
        });
    }

    validatePhoneNumber(code) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/api/2fa/validate-phone-number', code);
        });
    }

    resendTwoFA() {
        return window.axios.get('/api/2fa/reset');
    }

    resendSmsTwoFA(phone) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/api/2fa/resend', { phone: phone });
        });
    }

    changePassword(code) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/settings/change-password', code);
        });
    }

    confirmPassword(password) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/user/confirm-password', {
                password: password,
            });
        });
    }

    confirmFortifyPassword(password) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/user/confirm-password', {
                password: password,
            });
        });
    }

    async enableTwoFactor() {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/user/two-factor-authentication', {});
        });
    }

    async get2faQrCode() {
        return window.axios.get('/api/two-factor-qr-code');
    }

    async verify2faQrCode(code) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post(
                '/api/user/confirmed-two-factor-authentication',
                { code: code }
            );
        });
    }

    async getRecoveryCodes() {
        return window.axios.get('/api/user/two-factor-recovery-codes');
    }

    async twoFactorChallenge(data) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/user/two-factor-challenge', data);
        });
    }

    async disableTwoFactor() {
        const data = { _method: 'delete' };
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.post('/user/two-factor-authentication', data);
        });
    }

    async updateUser(data) {
        return window.axios.get('/sanctum/csrf-cookie').then(() => {
            return window.axios.put('/user/profile-information', data);
        });
    }
}
export default new Auth();
